 
document.addEventListener('DOMContentLoaded', function () {
  function cleanText(str) {
    return (str || '').replace(/\s+/g, ' ').trim();
  }

  function labelFastSimonPrices(root) {
    var scope = root || document;
    var containers = Array.prototype.slice.call(scope.querySelectorAll('.price-container.fs-serp-price, .compare-container'));
    if (scope.matches && scope.matches('.price-container.fs-serp-price, .compare-container')) containers.unshift(scope);

    containers.forEach(function (container) {
      var labelText = container.classList.contains('compare-container') || container.classList.contains('price-regular')
        ? 'Regular Price'
        : container.classList.contains('price-is-compare')
          ? 'Sale Price'
          : 'Regular Price';
      var label = container.querySelector('.visually-hidden');

      if (!label) {
        label = document.createElement('span');
        label.className = 'visually-hidden';
        container.insertBefore(label, container.firstChild);
      }
      label.textContent = labelText;
    });
  }

  function clarifyPriceLabels(root) {
    var scope = root || document;
    var selector = '.price__regular .visually-hidden--inline, .price__sale .visually-hidden--inline';
    var labels = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) labels.unshift(scope);

    labels.forEach(function (label) {
      var text = cleanText(label.textContent);
      if (text === 'Regular') label.textContent = 'Regular Price';
      if (text === 'Sale') label.textContent = 'Sale Price';
    });
  }

  function carouselSections(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('section[data-section-type="carousel-section"]'));
    if (scope.matches && scope.matches('section[data-section-type="carousel-section"]')) sections.unshift(scope);
    return sections;
  }

  function addViewAllLabels(root) {
    carouselSections(root).forEach(function (section) {
        var heading = section.querySelector('.section-title h2');
        var link = section.querySelector('.view-all-button');

        if (!heading || !link) return;

        var linkText = cleanText(link.textContent);
        var headingText = cleanText(heading.textContent);

        if (linkText && headingText) {
          link.setAttribute('aria-label', linkText + ', ' + headingText);
        }
      });
  }

  function addFeaturedCarouselLabels(root) {
    carouselSections(root).forEach(function (section) {
        var carousel = section.querySelector('.featured__collection-carousel');
        if (!carousel) return;

        var heading = section.querySelector('.section-title h2');
        carousel.setAttribute('role', 'region');
        carousel.setAttribute('aria-roledescription', 'carousel');
        if (heading) {
          if (!heading.id) heading.id = 'featured-collection-heading-' + (section.getAttribute('data-section-id') || '');
          carousel.setAttribute('aria-labelledby', heading.id);
        } else {
          carousel.setAttribute('aria-label', 'Featured products');
        }

        var slides = carousel.querySelectorAll('.featured__collection-product');
        slides.forEach(function (slide, index) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', (index + 1) + ' of ' + slides.length);
        });

        carousel.querySelectorAll('.flickity-prev-next-button').forEach(function (button) {
          var direction = button.classList.contains('previous') ? 'Previous' : 'Next';
          button.setAttribute('aria-label', direction + ' products');
        });

        syncVisibleCarouselSlides(carousel);
      });
  }

  // Scroll focused slides into view and announce visible products after navigation
  function syncVisibleCarouselSlides(carousel) {
    var flickity = window.Flickity && window.Flickity.data(carousel);
    if (!flickity || carousel._a11yFlickity === flickity) return;
    carousel._a11yFlickity = flickity;

    flickity.cells.forEach(function (cell) {
      cell.element.removeAttribute('aria-hidden');
    });

    var status = carousel.parentNode.querySelector('.a11y-carousel-status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'a11y-carousel-status visually-hidden';
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      carousel.parentNode.insertBefore(status, carousel.nextSibling);
    }

    function isFullyVisible(slide) {
      var viewportRect = flickity.viewport.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      return slideRect.left >= viewportRect.left - 1 && slideRect.right <= viewportRect.right + 1;
    }

    function announceVisibleSlides() {
      var visible = flickity.cells
        .map(function (cell, index) { return { el: cell.element, number: index + 1 }; })
        .filter(function (item) { return isFullyVisible(item.el); })
        .sort(function (a, b) { return a.el.getBoundingClientRect().left - b.el.getBoundingClientRect().left; })
        .map(function (item) { return item.number; });

      if (!visible.length) return;
      status.textContent = 'Showing products ' + visible.join(', ') + ' of ' + flickity.cells.length;
    }

    var announcePending = false;
    carousel.addEventListener('click', function (event) {
      if (event.target.closest('.flickity-prev-next-button')) announcePending = true;
    });
    carousel.addEventListener('keydown', function (event) {
      if (event.target === carousel && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) announcePending = true;
    });
    flickity.on('settle', function () {
      if (!announcePending) return;
      announcePending = false;
      announceVisibleSlides();
    });

    carousel.addEventListener('focusin', function (event) {
      var cell = flickity.getParentCell(event.target);
      var slide = cell && cell.element;
      if (!slide) return;
      // Undo the browser's native scroll so Flickity stays in sync
      flickity.viewport.scrollLeft = 0;
      if (isFullyVisible(slide)) return;
      var index = flickity.cells.map(function (cell) { return cell.element; }).indexOf(slide);
      if (index > -1) flickity.select(index, false, true);
    });
  }

  // Close hover-opened menus on Escape until the pointer leaves
  var DISMISSED_CLASS = 'a11y-hover-dismissed';

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var hoveredItems = Array.prototype.filter.call(
      document.querySelectorAll('header [data-active-class]'),
      function (item) {
        return item.matches(':hover') && !item.classList.contains(DISMISSED_CLASS) &&
          item.querySelector(':scope > .dropdown, :scope > .megamenu');
      }
    );

    if (!hoveredItems.length) return;

    hoveredItems.forEach(function (item) {
      item.classList.add(DISMISSED_CLASS);
      item.addEventListener('mouseleave', function () {
        item.classList.remove(DISMISSED_CLASS);
      }, { once: true });
    });

    // Return focus to the disclosure button if it was inside the hidden panel
    var topItem = hoveredItems[0];
    document.addEventListener('keyup', function () {
      setTimeout(function () {
        var active = document.activeElement;
        if (!active || !topItem.contains(active) || active.getClientRects().length) return;
        var disclosure = topItem.querySelector(':scope > .js-nav-disclosure');
        if (disclosure) disclosure.focus();
      }, 0);
    }, { once: true });
  });

  // Quick view button labels
  function labelQuickViewButtons(root) {
    var scope = root || document;
    var buttons = Array.prototype.slice.call(scope.querySelectorAll('.product-listing__quickview-trigger'));
    if (scope.matches && scope.matches('.product-listing__quickview-trigger')) buttons.unshift(scope);

    buttons.forEach(function (button) {
      var card = button.closest('.product-index') || button.closest('.ci') || button.parentNode;
      var titleEl = card && card.querySelector('.product-details h3');
      var imageLink = button.parentNode.querySelector('a[title]');
      var title = cleanText(titleEl ? titleEl.textContent : imageLink ? imageLink.getAttribute('title') : '');

      button.setAttribute('aria-label', title ? 'Quick view, ' + title : 'Quick view');
      button.setAttribute('aria-haspopup', 'dialog');
      button.querySelectorAll('svg').forEach(function (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      });
    });
  }

  // Return focus to the quick view button that opened the drawer
  var lastQuickViewTrigger = null;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.js-quickview-trigger');
    if (trigger) lastQuickViewTrigger = trigger;
  }, true);

  function watchQuickViewContainer(container, activeClass) {
    if (!container) return;
    var wasOpen = container.classList.contains(activeClass);

    new MutationObserver(function () {
      var isOpen = container.classList.contains(activeClass);
      if (wasOpen && !isOpen && lastQuickViewTrigger) {
        var trigger = lastQuickViewTrigger;
        lastQuickViewTrigger = null;
        setTimeout(function () {
          if (document.contains(trigger) && trigger.getClientRects().length) trigger.focus();
        }, 0);
      }
      wasOpen = isOpen;
    }).observe(container, { attributes: true, attributeFilter: ['class'] });
  }

  watchQuickViewContainer(document.querySelector('[data-wau-slideout="quickview"]'), 'slideout--active');
  watchQuickViewContainer(document.querySelector('[data-wau-modal="quickview"]'), 'modal--active');

  // Product card image flip: one image read at a time, second image shown on focus
  function setUpImageFlip(root) {
    var scope = root || document;
    scope.querySelectorAll('.prod-image > a').forEach(function (link) {
      var reveal = link.querySelector('.reveal');
      var secondary = reveal && reveal.querySelector(':scope > .hidden');
      var primary = reveal && reveal.querySelector(':scope > .box-ratio');
      if (!secondary || !primary || link._a11yFlip) return;
      link._a11yFlip = true;

      var secondaryImg = secondary.querySelector('img');
      var hasSecondaryAlt = secondaryImg && cleanText(secondaryImg.getAttribute('alt'));
      secondary.setAttribute('aria-hidden', 'true');

      link.addEventListener('focus', function () {
        link.parentNode.classList.add('a11y-flip');
        if (!hasSecondaryAlt) return;
        primary.setAttribute('aria-hidden', 'true');
        secondary.removeAttribute('aria-hidden');
      });

      link.addEventListener('blur', function () {
        link.parentNode.classList.remove('a11y-flip');
        primary.removeAttribute('aria-hidden');
        secondary.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // Fast Simon recommendation carousels (rendered in a shadow root)
  var UPSELL_STYLE = [
    '.fs-recommendation-button:focus-visible, .fs-upsell-cross-sell-product a:focus-visible,',
    '.fs-upsell-cross-sell-product [tabindex="0"]:focus-visible { outline: 3px solid #005fcc; outline-offset: 2px; }',
    '.fs-upsell-cross-sell-product .fs-swatch-more:focus-visible { outline-offset: 4px; }',
    '.fs-upsell-cross-sell-product .fs-swatch-more { color: #626062 !important; }'
  ].join('\n');

  function makeKeyboardButton(el, label) {
    if (el.tagName !== 'BUTTON' && el.tagName !== 'A') {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      if (!el._a11yKeys) {
        el._a11yKeys = true;
        el.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          el.click();
        });
      }
    }
    el.setAttribute('aria-label', label);
    el.querySelectorAll('svg, img').forEach(function (icon) {
      icon.setAttribute('aria-hidden', 'true');
    });
  }

  function upsellTitle(root) {
    var heading = root.querySelector('h1, h2, h3, h4, [class*="title"]:not([class*="product"])');
    var text = heading && cleanText(heading.textContent);
    if (text) return text;
    var host = root.host && root.host.closest('.shopify-section, .shopify-app-block');
    heading = host && host.querySelector('h1, h2, h3');
    return (heading && cleanText(heading.textContent)) || 'Recommended products';
  }

  function enhanceUpsellWidget(root) {
    if (!root.getElementById('a11y-upsell-style')) {
      var style = document.createElement('style');
      style.id = 'a11y-upsell-style';
      style.textContent = UPSELL_STYLE;
      root.appendChild(style);
    }

    var title = upsellTitle(root);
    fixFinalSaleBadges(root);

    root.querySelectorAll('.fs-recommendation-widget-products-container').forEach(function (carousel) {
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-roledescription', 'carousel');
      carousel.setAttribute('aria-label', title);

      carousel.querySelectorAll(':scope > .fs-recommendation-button').forEach(function (button, index, all) {
        var isPrevious = button.querySelector('.fs-recommendation-left-arrow') || (all.length > 1 && index === 0);
        makeKeyboardButton(button, (isPrevious ? 'Previous' : 'Next') + ' products');
      });

      var cards = carousel.querySelectorAll('.fs-upsell-cross-sell-product');
      cards.forEach(function (card, index) {
        var nameEl = card.querySelector('.fs-recommendation-product-name-wrapper');
        var name = nameEl ? cleanText(nameEl.textContent) : '';

        card.setAttribute('role', 'group');
        card.setAttribute('aria-roledescription', 'slide');
        card.setAttribute('aria-label', (index + 1) + ' of ' + cards.length + (name ? ', ' + name : ''));

        card.querySelectorAll('.color-swatch-container[data-alt-url]').forEach(function (swatch) {
          var chip = swatch.querySelector('[aria-label]');
          var color = chip ? chip.getAttribute('aria-label') : cleanText(swatch.getAttribute('title'));
          if (chip) chip.removeAttribute('role');
          swatch.setAttribute('role', 'link');
          swatch.setAttribute('tabindex', '0');
          swatch.setAttribute('aria-label', (color || 'Color option') + (name ? ', ' + name : ''));
          if (!swatch._a11yKeys) {
            swatch._a11yKeys = true;
            swatch.addEventListener('keydown', function (event) {
              if (event.key === 'Enter') swatch.click();
            });
          }
        });

        var more = card.querySelector('.fs-swatch-more');
        var count = more && parseInt(more.textContent.replace(/\D/g, ''), 10);
        if (count) {
          more.setAttribute('aria-label', count + ' more ' + (count === 1 ? 'color' : 'colors') + (name ? ' for ' + name : ''));
        }

        var quickView = card.querySelector('.quick-view-wrapper');
        if (quickView) makeKeyboardButton(quickView, 'Quick view' + (name ? ', ' + name : ''));
      });
    });
  }

  function watchUpsellRoot(root) {
    if (root._a11yWatched) return;
    root._a11yWatched = true;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        observer.disconnect();
        enhanceUpsellWidget(root);
        observer.observe(root, { childList: true, subtree: true });
      });
    });

    enhanceUpsellWidget(root);
    observer.observe(root, { childList: true, subtree: true });
  }

  function findUpsellWidgets() {
    document.querySelectorAll('.shopify-app-block, [id*="fast-simon"], [class*="fast-simon"]').forEach(function (block) {
      [block].concat(Array.prototype.slice.call(block.querySelectorAll('*'))).forEach(function (el) {
        if (el.shadowRoot && el.shadowRoot.querySelector('.fs-recommendation-widget-products-container')) {
          watchUpsellRoot(el.shadowRoot);
        }
      });
    });
  }

  findUpsellWidgets();
  window.addEventListener('fast-upsell-cross-sell-ready', function () {
    setTimeout(findUpsellWidgets, 0);
  });

  var upsellSearchTimer = null;
  new MutationObserver(function () {
    clearTimeout(upsellSearchTimer);
    upsellSearchTimer = setTimeout(findUpsellWidgets, 300);
  }).observe(document.body, { childList: true, subtree: true });

  // External link warning
  var EXTERNAL_LINK_TEXT = 'Redirecting to a third-party website, opens in a new tab';

  function normalizeHost(host) {
    return (host || '').toLowerCase().replace(/^www\./, '');
  }

  var internalHosts = [normalizeHost(window.location.hostname)];
  if (window.Shopify && window.Shopify.shop) internalHosts.push(normalizeHost(window.Shopify.shop));

  // Account links redirect to Shopify customer accounts on shopify.com
  var ACCOUNT_PATHS = /^\/(account(?!\/logout)|customer_authentication)(\/|$)/;

  function isExternalLink(link) {
    if (!/^https?:$/.test(link.protocol)) return false;
    if (ACCOUNT_PATHS.test(link.pathname)) return true;
    return internalHosts.indexOf(normalizeHost(link.hostname)) === -1;
  }

  function markExternalLinks(root) {
    var scope = root || document;
    var links = Array.prototype.slice.call(scope.querySelectorAll('a[href]'));
    if (scope.matches && scope.matches('a[href]')) links.unshift(scope);

    links.forEach(function (link) {
      if (link.dataset.a11yExternal || !isExternalLink(link)) return;
      link.dataset.a11yExternal = 'true';

      link.setAttribute('target', '_blank');
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      ['noopener', 'noreferrer'].forEach(function (value) {
        if (rel.indexOf(value) === -1) rel.push(value);
      });
      link.setAttribute('rel', rel.join(' '));

      var ariaLabel = link.getAttribute('aria-label');
      if (ariaLabel) {
        if (ariaLabel.indexOf(EXTERNAL_LINK_TEXT) === -1) {
          link.setAttribute('aria-label', cleanText(ariaLabel) + ', ' + EXTERNAL_LINK_TEXT);
        }
        return;
      }

      var warning = document.createElement('span');
      warning.className = 'visually-hidden';
      warning.textContent = ' ' + EXTERNAL_LINK_TEXT;
      link.appendChild(warning);
    });
  }

  // Phone and email link labels
  function labelContactLinks(root) {
    var scope = root || document;
    var selector = 'a[href^="tel:"], a[href^="mailto:"]';
    var links = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) links.unshift(scope);

    links.forEach(function (link) {
      var href = link.getAttribute('href');
      var isPhone = href.indexOf('tel:') === 0;
      var text = cleanText(link.textContent);
      if (!text) {
        text = href.replace(/^(tel|mailto):/, '').split('?')[0];
        try { text = decodeURIComponent(text); } catch (e) {}
      }
      if (!text) return;

      link.setAttribute('aria-label', (isPhone ? 'Phone Number: ' : 'Email address: ') + text);
    });
  }

  // Hidden variant select added outside the theme templates
  function labelVariantSelects(root) {
    var scope = root || document;
    var selects = Array.prototype.slice.call(scope.querySelectorAll('select[name="id"]'));
    if (scope.matches && scope.matches('select[name="id"]')) selects.unshift(scope);

    selects.forEach(function (select) {
      if (select.getAttribute('aria-label') || select.labels && select.labels.length) return;
      select.setAttribute('aria-label', 'Product variant');
    });
  }

  // Product variant swatches: radio group with sold out state
  function updateSwatchLabel(radio) {
    var swatch = radio.closest('.swatch-element');
    var soldOut = swatch && swatch.classList.contains('soldout');
    radio.setAttribute('aria-label', radio.value + (soldOut ? ', sold out' : ''));
  }

  function setUpVariantSwatches(root) {
    var scope = root || document;
    scope.querySelectorAll('.swatches__container').forEach(function (container) {
      var name = container.querySelector('.swatches__option-name strong');
      container.setAttribute('role', 'radiogroup');
      if (name) container.setAttribute('aria-label', cleanText(name.textContent).replace(/:$/, ''));

      container.querySelectorAll('.swatches__form--label').forEach(function (label) {
        label.removeAttribute('tabindex');
        label.setAttribute('aria-hidden', 'true');
      });

      container.querySelectorAll('.swatches__form--input').forEach(updateSwatchLabel);

      if (container._a11ySwatches) return;
      container._a11ySwatches = true;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var radio = mutation.target.querySelector('.swatches__form--input');
          if (radio) updateSwatchLabel(radio);
        });
      }).observe(container, { attributes: true, attributeFilter: ['class'], subtree: true });
    });
  }

  // Final sale text in product descriptions
  function colorFinalSaleText(root) {
    var scope = root || document;
    scope.querySelectorAll('.rte [style*="color"], .rte font[color]').forEach(function (el) {
      if (!/final\s*sale/i.test(el.textContent)) return;
      el.removeAttribute('color');
      el.style.setProperty('color', '#E62600', 'important');
    });
  }

  // Play/pause button for background videos
  var PAUSE_ICON = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><rect x="2" y="1" width="3.5" height="12" fill="currentColor"/><rect x="8.5" y="1" width="3.5" height="12" fill="currentColor"/></svg>';
  var PLAY_ICON = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M3 1l10 6-10 6z" fill="currentColor"/></svg>';

  function setUpVideoToggles(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('[data-section-type="background-video"]'));
    if (scope.matches && scope.matches('[data-section-type="background-video"]')) sections.unshift(scope);
    if (!sections.length && scope.closest) {
      var parent = scope.closest('[data-section-type="background-video"]');
      if (parent) sections.push(parent);
    }

    sections.forEach(function (section) {
      var wrapper = section.querySelector('.background-video__outer-wrapper');
      var video = section.querySelector('video');
      if (!wrapper || !video || wrapper.querySelector('.a11y-video-toggle')) return;

      var descriptionId = 'a11y-video-description-' + (section.dataset.sectionId || Date.now());
      var description = document.createElement('span');
      description.id = descriptionId;
      description.className = 'visually-hidden';
      description.textContent = 'Decorative background video with no sound';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'a11y-video-toggle';
      button.setAttribute('aria-describedby', descriptionId);

      video.setAttribute('aria-hidden', 'true');

      function render() {
        var paused = video.paused;
        button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        button.innerHTML = paused ? PLAY_ICON : PAUSE_ICON;
      }

      button.addEventListener('click', function () {
        if (video.paused) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', render);
      video.addEventListener('pause', render);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();

      render();
      wrapper.appendChild(description);
      wrapper.appendChild(button);
    });
  }

  // Flickity hides non-selected slides; keep that in sync with focus
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])';

  function syncFlickitySlide(slide) {
    if (slide.closest('.featured__collection-carousel, .js-thumb-carousel-nav, .recently-viewed-products--carousel')) {
      if (slide.hasAttribute('aria-hidden')) slide.removeAttribute('aria-hidden');
      return;
    }

    var hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.inert = hidden;
    if (hidden) {
      slide.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (el.dataset.a11yTabindex !== undefined) return;
        el.dataset.a11yTabindex = el.getAttribute('tabindex') || '';
        el.setAttribute('tabindex', '-1');
      });
    } else {
      slide.querySelectorAll('[data-a11y-tabindex]').forEach(function (el) {
        if (el.dataset.a11yTabindex) {
          el.setAttribute('tabindex', el.dataset.a11yTabindex);
        } else {
          el.removeAttribute('tabindex');
        }
        delete el.dataset.a11yTabindex;
      });
    }
  }

  function syncFlickitySlides(root) {
    (root || document).querySelectorAll('.flickity-slider > *').forEach(syncFlickitySlide);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.parentNode && mutation.target.parentNode.classList &&
          mutation.target.parentNode.classList.contains('flickity-slider')) {
        syncFlickitySlide(mutation.target);
      }
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });

  // Fast Simon price filter inputs
  function labelPriceInputs(root) {
    var scope = root || document;
    var inputs = Array.prototype.slice.call(scope.querySelectorAll('input.price-input'));
    if (scope.matches && scope.matches('input.price-input')) inputs.unshift(scope);

    inputs.forEach(function (input) {
      if (input.getAttribute('aria-label')) return;
      var box = input.closest('[class*="slider-input-box"]');
      var isMax = (box && /slider-input-box-max/.test(box.className)) || /max/i.test(input.id);
      input.setAttribute('aria-label', isMax ? 'Maximum price' : 'Minimum price');
    });
  }

  // Product gallery arrows, Space key and selection announcement
  function labelGalleryArrows(root) {
    (root || document).querySelectorAll('.js-carousel-main .flickity-prev-next-button').forEach(function (button) {
      button.setAttribute('aria-label', button.classList.contains('previous') ? 'Previous image' : 'Next image');
      button.querySelectorAll('svg').forEach(function (svg) {
        svg.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function setUpProductGallery(root) {
    var scope = root || document;
    labelGalleryArrows(scope);
    scope.querySelectorAll('.js-product-gallery').forEach(function (gallery) {
      var nav = gallery.querySelector('.js-thumb-carousel-nav');
      var main = gallery.querySelector('.js-carousel-main');
      var source = nav || main;
      var itemSelector = nav ? '.js-thumb-item' : '.carousel-cell';
      var selectedClass = nav ? 'is-nav-selected' : 'is-selected';
      if (!source) return;

      var total = source.querySelectorAll(itemSelector).length;
      if (gallery._a11yGallery) return;
      gallery._a11yGallery = true;

      var status = gallery.querySelector('.js-gallery-status');
      if (!status) return;

      var pending = false;
      gallery.addEventListener('click', function (event) {
        if (event.target.closest('.js-thumb-item, .flickity-prev-next-button')) pending = true;
      });
      gallery.addEventListener('keydown', function (event) {
        var thumb = event.target.closest('.js-thumb-item');
        if (thumb && event.key === ' ') {
          event.preventDefault();
          thumb.click();
        }
        if (['Enter', ' ', 'ArrowLeft', 'ArrowRight'].indexOf(event.key) > -1) pending = true;
      });
      gallery.addEventListener('pointerdown', function () {
        pending = true;
      });

      new MutationObserver(function (mutations) {
        if (!pending) return;
        mutations.forEach(function (mutation) {
          var item = mutation.target;
          if (!item.matches(itemSelector) || !item.classList.contains(selectedClass)) return;
          if (mutation.oldValue && mutation.oldValue.split(' ').indexOf(selectedClass) > -1) return;
          pending = false;
          var index = Array.prototype.indexOf.call(source.querySelectorAll(itemSelector), item);
          status.textContent = '';
          setTimeout(function () {
            status.textContent = 'Product image ' + (index + 1) + ' of ' + total + ' visible in gallery viewer.';
          }, 100);
        });
      }).observe(source, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
    });
  }

  // Announce quantity after increase/decrease
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.quantity-control-up, .quantity-control-down');
    if (!button) return;
    var wrapper = button.closest('.product-qty');
    var input = wrapper && wrapper.querySelector('input[name="quantity"]');
    var status = wrapper && wrapper.querySelector('.js-qty-status');
    if (!input || !status) return;

    setTimeout(function () {
      status.textContent = '';
      setTimeout(function () {
        status.textContent = 'Quantity ' + input.value;
      }, 50);
    }, 0);
  });

  // Shipping and returns dialog
  function setUpShippingDialog(root) {
    var scope = root || document;
    scope.querySelectorAll('.shipping-and-returns__popup').forEach(function (popup) {
      if (popup._a11yDialog) return;
      popup._a11yDialog = true;

      var dialog = popup.querySelector('[role="dialog"]');
      var opener = document.querySelector('.shipping-and-returns__button');
      if (!dialog) return;

      function close() {
        popup.classList.remove('pop-up-open');
      }

      function focusables() {
        return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
          return el.getClientRects().length;
        });
      }

      new MutationObserver(function () {
        var isOpen = popup.classList.contains('pop-up-open');
        if (isOpen === popup._a11yOpen) return;
        popup._a11yOpen = isOpen;

        if (opener) opener.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          setTimeout(function () { dialog.focus(); }, 50);
        } else if (opener) {
          opener.focus();
        }
      }).observe(popup, { attributes: true, attributeFilter: ['class'] });

      popup.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;

        var items = focusables();
        if (!items.length) {
          event.preventDefault();
          return;
        }
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  }

  // Announcement bar carousel
  function labelAnnouncementArrows(carousel) {
    carousel.querySelectorAll('.flickity-prev-next-button').forEach(function (button) {
      button.setAttribute('aria-label', button.classList.contains('previous') ? 'Previous announcement' : 'Next announcement');
      button.querySelectorAll('svg').forEach(function (svg) {
        svg.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function setUpAnnouncementBar(root) {
    var scope = root || document;
    var carousels = Array.prototype.slice.call(scope.querySelectorAll('.js-announcement-carousel'));
    if (scope.matches && scope.matches('.js-announcement-carousel')) carousels.unshift(scope);

    carousels.forEach(function (carousel) {
      labelAnnouncementArrows(carousel);
      if (carousel.classList.contains('flickity-enabled')) carousel.removeAttribute('tabindex');
      syncFlickitySlides(carousel);

      var flickity = window.Flickity && window.Flickity.data(carousel);
      if (!flickity || carousel._a11yFlickity === flickity) return;
      carousel._a11yFlickity = flickity;

      var status = carousel.parentNode.querySelector('.js-announcement-status');
      if (!status) return;

      var pending = false;
      carousel.addEventListener('click', function (event) {
        if (event.target.closest('.flickity-prev-next-button')) pending = true;
      });
      carousel.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') pending = true;
      });

      flickity.on('select', function (index) {
        if (!pending) return;
        pending = false;
        var slide = flickity.selectedElement;
        status.textContent = 'Announcement ' + (index + 1) + ' of ' + flickity.cells.length + ': ' + cleanText(slide.textContent);
      });
    });
  }

  // Theme recently viewed carousel
  function setUpRecentlyViewed(root) {
    var scope = root || document;
    var carousels = Array.prototype.slice.call(scope.querySelectorAll('.recently-viewed-products--carousel.flickity-enabled'));
    if (scope.matches && scope.matches('.recently-viewed-products--carousel.flickity-enabled')) carousels.unshift(scope);

    carousels.forEach(function (carousel) {
      var slides = carousel.querySelectorAll('.recently-viewed-products__product');
      slides.forEach(function (slide, index) {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', (index + 1) + ' of ' + slides.length);
      });

      carousel.querySelectorAll('.flickity-prev-next-button').forEach(function (button) {
        button.setAttribute('aria-label', button.classList.contains('previous') ? 'Previous products' : 'Next products');
        button.querySelectorAll('svg').forEach(function (svg) {
          svg.setAttribute('aria-hidden', 'true');
        });
      });

      var dots = carousel.querySelector('.flickity-page-dots');
      if (dots) dots.setAttribute('aria-hidden', 'true');

      syncFlickitySlides(carousel);
      syncVisibleCarouselSlides(carousel);
    });
  }

  // Fast Simon "Final Sale" badge contrast
  function fixFinalSaleBadges(root) {
    var scope = root || document;
    scope.querySelectorAll('.text-badge').forEach(function (badge) {
      if (!/final\s*sale/i.test(badge.textContent)) return;
      badge.style.setProperty('color', '#C21F00', 'important');
      badge.querySelectorAll('*').forEach(function (el) {
        el.style.setProperty('color', '#C21F00', 'important');
      });
    });
  }

  // App markup fixes (iubenda, Fast Simon, Judge.me, store locator, cookie bar)
  function queryAll(scope, selector) {
    var items = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) items.unshift(scope);
    return items;
  }

  function hasWord(text, word) {
    var escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(^|\\W)' + escaped + '(\\W|$)', 'i').test(text);
  }

  function fixAppMarkup(root) {
    var scope = root || document;

    // iubenda icons repeat the company name shown next to them
    queryAll(scope, '#iub-legalDoc img[role]').forEach(function (img) {
      img.setAttribute('alt', '');
      img.removeAttribute('role');
    });

    // iubenda policy adds a second <main> inside the page's <main>
    queryAll(scope, '#iub-legalDoc main').forEach(function (main) {
      var div = document.createElement('div');
      Array.prototype.forEach.call(main.attributes, function (attr) {
        div.setAttribute(attr.name, attr.value);
      });
      while (main.firstChild) div.appendChild(main.firstChild);
      main.parentNode.replaceChild(div, main);
    });

    // aria-disabled="false" conflicts with the disabled attribute
    queryAll(scope, '[disabled][aria-disabled="false"]').forEach(function (el) {
      el.removeAttribute('aria-disabled');
    });

    // aria-required duplicates the required attribute
    queryAll(scope, '[required][aria-required]').forEach(function (el) {
      el.removeAttribute('aria-required');
    });

    // Empty headings in page content
    queryAll(scope, '.rte h1, .rte h2, .rte h3, .rte h4, .rte h5, .rte h6').forEach(function (heading) {
      var empty = !cleanText(heading.textContent) && !heading.querySelector('img, svg, picture');
      if (empty && heading.getAttribute('aria-hidden') !== 'true') heading.setAttribute('aria-hidden', 'true');
    });

    // Accessible name must contain the visible label
    queryAll(scope, '#Avada-CookiesBar button[aria-label], .button-wrapper[role="button"][aria-label]').forEach(function (el) {
      var text = cleanText(el.textContent);
      if (text && !hasWord(el.getAttribute('aria-label'), text)) el.setAttribute('aria-label', text);
    });

    // Store locator map canvas and distance select
    queryAll(scope, 'canvas.mapboxgl-canvas[aria-label]').forEach(function (canvas) {
      if (canvas.getAttribute('role') !== 'region') canvas.setAttribute('role', 'region');
    });

    queryAll(scope, 'label[for="within_distance"]').forEach(function (label) {
      if (cleanText(label.textContent)) return;
      var text = document.createElement('span');
      text.className = 'visually-hidden';
      text.textContent = 'Search radius';
      label.appendChild(text);
    });

    // Fast Simon pagination arrows are icon-only links
    queryAll(scope, '#fs-serp-app a.arrow-button[href]').forEach(function (link) {
      var match = /[?&]page=(\d+)/.exec(link.getAttribute('href'));
      var current = /[?&]page=(\d+)/.exec(window.location.search);
      var target = match ? parseInt(match[1], 10) : null;
      var isPrevious = /prev|left|back/i.test(link.className + ' ' + (link.parentNode && link.parentNode.className))
        || (target !== null && target < (current ? parseInt(current[1], 10) : 1));
      var label = (isPrevious ? 'Previous page' : 'Next page') + (target !== null ? ', page ' + target : '');
      if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
      link.querySelectorAll('svg').forEach(function (svg) {
        if (svg.getAttribute('aria-hidden') !== 'true') svg.setAttribute('aria-hidden', 'true');
      });
    });

    // Links with no text or alt text (e.g. image links in collection descriptions)
    queryAll(scope, 'a[href]').forEach(function (link) {
      if (cleanText(link.textContent) || link.getAttribute('aria-hidden') === 'true') return;
      if (cleanText(link.getAttribute('aria-label')) || link.getAttribute('aria-labelledby') || cleanText(link.getAttribute('title'))) return;
      var named = Array.prototype.some.call(link.querySelectorAll('img[alt], [aria-label], svg title'), function (el) {
        return cleanText(el.getAttribute('alt') || el.getAttribute('aria-label') || el.textContent);
      });
      if (named) return;

      var path = (link.pathname || '').replace(/\/+$/, '');
      var slug = path.split('/').pop();
      var label = slug
        ? decodeURIComponent(slug).replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); })
        : 'Home';
      link.setAttribute('aria-label', label);
    });

    // Judge.me verified badge text contrast
    queryAll(scope, '.jm-text').forEach(function (el) {
      if (el.dataset.a11yContrast || cleanText(el.textContent) !== 'Verified') return;
      el.dataset.a11yContrast = 'true';
      el.style.setProperty('color', '#595959', 'important');
    });
  }

  function watchAppMarkup(root) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        fixAppMarkup(root);
      }, 50);
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'aria-disabled', 'aria-required', 'role']
    });
  }

  fixAppMarkup();
  watchAppMarkup(document.body);

  // Store locator widget, in case it renders into a shadow root
  var storeLocator = document.querySelector('w3-store-locator');
  if (storeLocator) {
    var checkLocatorShadow = setInterval(function () {
      if (!storeLocator.shadowRoot) return;
      clearInterval(checkLocatorShadow);
      fixAppMarkup(storeLocator.shadowRoot);
      watchAppMarkup(storeLocator.shadowRoot);
    }, 500);
    setTimeout(function () { clearInterval(checkLocatorShadow); }, 15000);
  }

  addViewAllLabels();
  addFeaturedCarouselLabels();
  labelFastSimonPrices();
  clarifyPriceLabels();
  labelQuickViewButtons();
  setUpImageFlip();
  markExternalLinks();
  labelContactLinks();
  labelVariantSelects();
  setUpVariantSwatches();
  colorFinalSaleText();
  setUpVideoToggles();
  syncFlickitySlides();
  labelPriceInputs();
  setUpProductGallery();
  setUpShippingDialog();
  setUpAnnouncementBar();
  setUpRecentlyViewed();
  fixFinalSaleBadges();

  // Re-run when a section is added or edited in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    addViewAllLabels(e.target);
    addFeaturedCarouselLabels(e.target);
    labelFastSimonPrices(e.target);
    clarifyPriceLabels(e.target);
    labelQuickViewButtons(e.target);
    setUpImageFlip(e.target);
    markExternalLinks(e.target);
    labelContactLinks(e.target);
    labelVariantSelects(e.target);
    setUpVariantSwatches(e.target);
    colorFinalSaleText(e.target);
    setUpVideoToggles(e.target);
    syncFlickitySlides(e.target);
    setUpProductGallery(e.target);
    setUpShippingDialog(e.target);
    setUpAnnouncementBar(e.target);
  });

  // Flickity adds its navigation buttons after initialization.
  var carouselObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.target.matches('.featured__collection-carousel.flickity-enabled')) {
        addFeaturedCarouselLabels(mutation.target.closest('section'));
      }
      if (mutation.type === 'attributes' && mutation.target.matches('.flickity-enabled')) {
        syncFlickitySlides(mutation.target);
        if (mutation.target.matches('.js-announcement-carousel')) setUpAnnouncementBar(mutation.target);
        if (mutation.target.matches('.recently-viewed-products--carousel')) setUpRecentlyViewed(mutation.target);
      }
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.parentNode && node.parentNode.classList && node.parentNode.classList.contains('flickity-slider')) {
          syncFlickitySlide(node);
        }
        labelFastSimonPrices(node);
        clarifyPriceLabels(node);
        labelQuickViewButtons(node);
        setUpImageFlip(node);
        markExternalLinks(node);
        labelContactLinks(node);
        labelVariantSelects(node);
        setUpVariantSwatches(node);
        labelPriceInputs(node);
        fixFinalSaleBadges(node);
        if (node.matches('video') || node.querySelector('video')) setUpVideoToggles(node);
        if (node.matches('.flickity-prev-next-button') || node.querySelector('.flickity-prev-next-button')) {
          addFeaturedCarouselLabels(node.closest('section') || document);
          labelGalleryArrows(node.closest('.js-product-gallery') || document);
          var announcement = node.closest('.js-announcement-carousel');
          if (announcement) labelAnnouncementArrows(announcement);
        }
      });
    });
  });
  carouselObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
});
